import { onPath } from '../utils/path';
import { selectOne, addClass, removeClass, getWindow } from '../utils/dom-utils';


onPath('/live-chat-powered-by-olark', () => {
  const win = getWindow();

  const yesButton = selectOne('#yes-button');
  const noButton = selectOne('#no-button');
  const introDiv = selectOne('#intro');
  const responseYes = selectOne("#response-yes");
  const responseNo = selectOne("#response-no");

  yesButton.addEventListener('click', function(){
    addClass(introDiv, 'tw-hidden');
    removeClass(responseYes,'tw-hidden');
    history.pushState({page: 'yes'}, "title 1", "#yes");
  });

  noButton.addEventListener('click', function(){
    addClass(introDiv, 'tw-hidden');
    removeClass(responseNo,'tw-hidden');
    history.pushState({page: 'no'}, "title 1", "#no");
  });

  // support hitting back button after selecting yes or no
  win.addEventListener('popstate', function(e){
    removeClass(introDiv, 'tw-hidden');
    addClass(responseYes, 'tw-hidden');
    addClass(responseNo,'tw-hidden');
  });


});

